import gql from "graphql-tag";

const officeFieldsFragment = gql`
  fragment OfficeFields on Office {
    id
    version
    status
    contact {
      id
      version
      alias
      firstName
      lastName
      photoId
      type
      emails {
        id
        version
        address
      }
    }
  }
`;

const findOfficeByIdQuery = gql`
  query($id: UUID) {
    findOfficeById(id: $id) {
      ...OfficeFields
    }
  }
  ${officeFieldsFragment}
`;

const findOfficesByNameQuery = gql`
  query findOfficesByName(
    $business: BusinessInput
    $name: String
    $startIndex: Int
    $stopIndex: Int
  ) {
    findOfficesByName(
      name: $name
      business: $business
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "id" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        contact {
          id
          version
          alias
        }
      }
    }
  }
`;

const findActiveOfficesByNameQuery = gql`
  query(
    $business: BusinessInput
    $name: String
    $startIndex: Int
    $stopIndex: Int
  ) {
    findActiveOfficesByName(
      name: $name
      business: $business
      pageable: {
        startIndex: $startIndex
        stopIndex: $stopIndex
        _type_: Range
        sort: { orders: [{ direction: "ASC", property: "id" }] }
      }
    ) {
      numberOfElements
      totalPages
      totalElements
      size
      number
      content {
        id
        version
        contact {
          id
          version
          companyName
          alias
        }
      }
    }
  }
`;

const saveOfficeMutation = gql`
  mutation($office: OfficeInput) {
    saveOffice2(office: $office) {
      ...OfficeFields
    }
  }
  ${officeFieldsFragment}
`;

const deleteOfficeMutation = gql`
  mutation($office: OfficeInput) {
    deleteOffice(office: $office) {
      id
      version
    }
  }
`;

export {
  findOfficeByIdQuery,
  findOfficesByNameQuery,
  findActiveOfficesByNameQuery,
  saveOfficeMutation,
  deleteOfficeMutation
};
